import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";
import tunjanganLainService from "./tunjanganLainService";

const  presensiProyekService = {}

presensiProyekService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/presensi_proyek/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

presensiProyekService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/presensi_proyek/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

presensiProyekService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/presensi_proyek/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

presensiProyekService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/presensi_proyek/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}


export default presensiProyekService;
